import gsap from 'gsap';

class Nav {
	constructor() {
		let cache = {};
		let isOpen = false;
		let isAnimating = false;

		let initFunc = () => {
			initCache();
			if (!cache.toggle || !cache.overlay) return;
			registerEvents();
		};

		let initCache = () => {
			cache.toggle = document.querySelector('.nav-toggle');
			cache.overlay = document.querySelector('.nav-overlay');
			if (!cache.toggle || !cache.overlay) return;
			cache.label = cache.toggle.querySelector('.nav-toggle__label');
			cache.line1 = cache.toggle.querySelector('.line-1');
			cache.line2 = cache.toggle.querySelector('.line-2');
			cache.menuItems = cache.overlay.querySelectorAll('.nav-overlay__menu li');
			cache.footerEl = cache.overlay.querySelector('.nav-overlay__footer');
		};

		let registerEvents = () => {
			cache.toggle.addEventListener('click', handleToggle);
		};

		let handleToggle = () => {
			if (isAnimating) return;
			isAnimating = true;

			if (isOpen) {
				close();
			} else {
				open();
			}
		};

		let open = () => {
			const tl = gsap.timeline({
				onComplete: () => {
					isOpen = true;
					isAnimating = false;
				}
			});

			document.body.classList.add('overflow');
			document.documentElement.classList.add('overflow');

			// Icon morph: burger → cross
			tl.to(cache.line1, {
				attr: { y1: 8, y2: 8 },
				duration: 0.25,
				ease: 'power3.inOut'
			}, 0);

			tl.to(cache.line2, {
				attr: { y1: 8, y2: 8 },
				duration: 0.25,
				ease: 'power3.inOut'
			}, 0);

			tl.to(cache.line1, {
				attr: { x1: 2.18, y1: 3.25, x2: 12.08, y2: 13.15 },
				duration: 0.4,
				ease: 'power2.out'
			}, 0.2);

			tl.to(cache.line2, {
				attr: { x1: 1.87, y1: 13.2, x2: 11.77, y2: 3.31 },
				duration: 0.4,
				ease: 'power2.out'
			}, 0.2);

			// Label text
			tl.to(cache.label, {
				opacity: 0,
				duration: 0.15,
				ease: 'power2.out',
				onComplete: () => {
					cache.label.textContent = 'Menu';
				}
			}, 0);

			tl.to(cache.label, {
				opacity: 1,
				duration: 0.15,
				ease: 'power2.out'
			}, 0.15);

			// Overlay fade in
			tl.set(cache.overlay, { visibility: 'visible' }, 0);
			tl.to(cache.overlay, {
				opacity: 1,
				duration: 0.5,
				ease: 'power3.out'
			}, 0);

			// Menu items stagger
			tl.fromTo(cache.menuItems, {
				y: 40,
				opacity: 0
			}, {
				y: 0,
				opacity: 1,
				duration: 0.6,
				stagger: 0.06,
				ease: 'power3.out'
			}, 0.2);

			// Footer slide up
			if (cache.footerEl) {
				tl.fromTo(cache.footerEl, {
					y: 30,
					opacity: 0
				}, {
					y: 0,
					opacity: 1,
					duration: 0.6,
					ease: 'power3.out'
				}, 0.45);
			}
		};

		let close = () => {
			const tl = gsap.timeline({
				onComplete: () => {
					isOpen = false;
					isAnimating = false;
					gsap.set(cache.overlay, { visibility: 'hidden' });
				}
			});

			// Icon morph: cross → burger
			tl.to(cache.line1, {
				attr: { x1: 0, y1: 8, x2: 14, y2: 8 },
				duration: 0.3,
				ease: 'power3.inOut'
			}, 0);

			tl.to(cache.line2, {
				attr: { x1: 0, y1: 8, x2: 14, y2: 8 },
				duration: 0.3,
				ease: 'power3.inOut'
			}, 0);

			tl.to(cache.line1, {
				attr: { y1: 5, y2: 5 },
				duration: 0.35,
				ease: 'power2.out'
			}, 0.25);

			tl.to(cache.line2, {
				attr: { y1: 11, y2: 11 },
				duration: 0.35,
				ease: 'power2.out'
			}, 0.25);

			// Label text
			tl.to(cache.label, {
				opacity: 0,
				duration: 0.15,
				ease: 'power2.out',
				onComplete: () => {
					cache.label.textContent = 'Menu';
				}
			}, 0);

			tl.to(cache.label, {
				opacity: 1,
				duration: 0.15,
				ease: 'power2.out'
			}, 0.15);

			// Footer out
			if (cache.footerEl) {
				tl.to(cache.footerEl, {
					y: 20,
					opacity: 0,
					duration: 0.3,
					ease: 'power2.in'
				}, 0);
			}

			// Menu items out
			tl.to(cache.menuItems, {
				y: -20,
				opacity: 0,
				duration: 0.3,
				stagger: 0.03,
				ease: 'power2.in'
			}, 0);

			// Overlay fade out
			tl.to(cache.overlay, {
				opacity: 0,
				duration: 0.4,
				ease: 'power2.in'
			}, 0.15);

			document.body.classList.remove('overflow');
			document.documentElement.classList.remove('overflow');
		};

		initFunc();
	}
}

export { Nav };
